import { h as __h } from "preact";
import { Component } from "preact";
import { CSSTransition, TransitionGroup } from "preact-transitioning";
import { alerts, dismiss } from "~/util/alert.js";
/** @import { AlertItem } from "~/util/alert.js"; */
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Alerts.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Alerts.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {number | undefined} [offset]
 * @param {Props} props
 */
export function Alerts({
  offset = 0
}) {
  return __h("ul", {
    "class": css.alerts,
    style: "--alerts-offset: " + offset + "px"
  }, __h(TransitionGroup, {
    duration: 200,
    children: []
  }, alerts.value.map(alert => __h(CSSTransition, {
    key: alert.id,
    classNames: {
      appear: (/** @type {string} */css.alertAppear),
      appearActive: (/** @type{string} */css.alertAppearActive),
      exitActive: (/** @type{string} */css.alertExitActive)
    }
  }, __h("li", {
    "class": css.alertitem
  }, __h(Alert, {
    alert: alert
  }))))));
}

/**
 * @extends {Component<AlertProps>}
 *
 * @typedef {object} AlertProps
 * @property {AlertItem} alert
 */
class Alert extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #timeout;

  /** @param {number} ms */
  #queueDismiss(ms) {
    clearTimeout(this.#timeout);

    // `setTimeout` treats delay values higher than this magic number as 1
    const delay = Math.min(ms, 2147483647);
    this.#timeout = setTimeout(this.dismiss, delay);
  }

  /** @override */
  componentDidMount() {
    this.#queueDismiss(this.props.alert.ms);
  }

  /**
   * @param {{ alert: AlertItem }} next
   * @override
   */
  componentWillReceiveProps(next) {
    if (next.alert.ms === this.props.alert.ms) return;
    this.#queueDismiss(next.alert.ms);
  }

  /** @override */
  componentWillUnmount() {
    clearTimeout(this.#timeout);
  }
  dismiss = () => dismiss(this.props.alert.id);
  enter = () => clearTimeout(this.#timeout);
  leave = () => this.#queueDismiss(this.props.alert.ms);
  render() {
    const {
      alert
    } = this.props;
    return __h("div", {
      "class": css.alert,
      onPointerEnter: this.enter,
      onPointerLeave: this.leave
    }, __h("div", {
      "class": css.icon,
      "data-type": alert.type
    }, __h(Icon, {
      name: alert.type === "success" ? "check" : alert.type === "info" ? "info" : "warning"
    })), __h("span", {
      "class": css.label
    }, alert.message), alert.actions.length ? __h("ul", {
      "class": css.actions
    }, alert.actions.map((action, i) => __h("li", {
      key: i
    }, __h("button", {
      "class": css.action,
      onClick: action.onSelect
    }, action.text)))) : null, __h("button", {
      "class": css.close,
      onClick: this.dismiss
    }, __h(Icon, {
      name: "ex",
      size: 8,
      label: "dismiss"
    })));
  }
}